<template>
    <ContentWrapper>
        <v-card tile>
            <v-card-title class="error white--text">Diese Seite gibt es nicht (mehr)!</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                Versuchen sie ggf. die Seite "{{$route.fullPath}}" im <a :href="oldUrl()" target="_blank">Archiv</a> aufzurufen.
            </v-card-text>
        </v-card>
    </ContentWrapper>
</template>
<script>
    import ContentWrapper from "../components/ContentWrapper";
    export default {
        components: {ContentWrapper},
        methods: {
            oldUrl () {
                return `http://archiv.etc-ellerau.de${this.$route.fullPath}`
            }
        }
    }
</script>